import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';

type BorrowingBaseSummaryAccordionProps = {
  accordionButton: (props: {
    hasAccordionPanel: boolean;
    isExpanded: boolean;
  }) => React.ReactElement;
  accordionPanel?: React.ReactElement;
  defaultIsExpanded?: boolean;
};
export const BorrowingBaseSummaryAccordion = ({
  accordionButton,
  accordionPanel,
  defaultIsExpanded,
}: BorrowingBaseSummaryAccordionProps) => {
  const hasAccordionPanel = !!accordionPanel;

  return (
    <Accordion
      allowMultiple
      mb="16px"
      defaultIndex={defaultIsExpanded ? [0] : undefined} // if defaultIsExpanded === true, we will automatically expand the first AccordionItem. In the BorrowingBaseSummaryAccordion usage, there is only 1 AccordionItem per Accordion. We must pass in the index of the default as an array, since we have `allowMultiple` prop turned on
    >
      <AccordionItem
        borderRadius="8px"
        border={`1px solid ${colors.gray[200]}`}
      >
        {({ isExpanded }) => (
          <>
            <AccordionButton
              paddingInline="0"
              paddingBlock="0"
              _disabled={{ color: 'black', cursor: 'default' }}
            >
              {accordionButton({ hasAccordionPanel, isExpanded })}
            </AccordionButton>
            {accordionPanel && (
              <AccordionPanel>{accordionPanel}</AccordionPanel>
            )}
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
};
